import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@fetmode/i18n';
import { resolveAppUrl } from '../urls.js';
/** Studio recruit CTA — place after “Already a member? Sign in”. */
export function RegisterAsModelLink({ className = 'auth-legal__model', }) {
    const studioUrl = resolveAppUrl('studio', import.meta.env);
    return (_jsx("p", { className: className, children: _jsx("a", { href: studioUrl, children: t('common.auth.registerAsModel') }) }));
}
//# sourceMappingURL=RegisterAsModelLink.js.map